import { render } from "./DocNotes.vue?vue&type=template&id=00701634&scoped=true"
import script from "./DocNotes.vue?vue&type=script&lang=js"
export * from "./DocNotes.vue?vue&type=script&lang=js"

import "./DocNotes.vue?vue&type=style&index=0&id=00701634&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00701634"]])

export default __exports__